module.exports = __webpack_public_path__ + "static/media/error-page-top-right-image.d2163524.svg";